var _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2a5f9e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 60.3V46.5l-10.3 7.6c2.9 2.7 6.4 4.8 10.3 6.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 60.3c3.9-1.4 7.4-3.5 10.3-6.2L42 46.4v13.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7 42c.3 1 .7 1.9 1.2 2.9L8.8 42H3.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2 42l3.9 2.9c.4-.9.8-1.9 1.2-2.9h-5.1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 38H2.6c.3 1.4.7 2.7 1.1 4h5.1l-3.9 2.9c.8 1.7 1.7 3.2 2.8 4.7L18 42h4v2l-11.7 8.6l1.4 1.4L22 46.5v13.8c1.3.5 2.6.8 4 1.1V38h-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4 38H38v23.4c1.4-.3 2.7-.7 4-1.1V46.5L52.3 54c1.4-1.3 2.6-2.7 3.8-4.2L45.4 42h6.8l6.1 4.5c.3-.5.6-1.1.8-1.6L55.2 42h5.1c.4-1.3.8-2.6 1.1-4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ed4c5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7 49.6c.8 1.1 1.6 2.1 2.5 3.1L22 44.1v-2h-4L7.7 49.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 42l10.7 7.8c.4-.5.7-1 1.1-1.5c.1-.1.1-.2.2-.2c.3-.5.7-1.1 1-1.6L52.2 42h-6.7"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#2a5f9e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 3.7v13.8l10.3-7.6C49.4 7.2 45.9 5.1 42 3.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 3.7c-3.9 1.4-7.4 3.5-10.3 6.2L22 17.6V3.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3 22c-.3-1-.7-1.9-1.2-2.9L55.2 22h5.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8 22l-3.9-2.9c-.4 1-.8 1.9-1.2 2.9h5.1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 26h20.8c-.3-1.4-.7-2.7-1.1-4h-5.1l3.9-2.9c-.8-1.7-1.7-3.2-2.8-4.7L46 22h-4v-2l11.7-8.6l-1.4-1.4L42 17.5V3.7c-1.3-.5-2.6-.8-4-1.1V26h2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6 26H26V2.6c-1.4.3-2.7.7-4 1.1v13.8L11.7 10c-1.4 1.3-2.6 2.7-3.8 4.2L18.6 22h-6.8l-6.1-4.5c-.3.5-.6 1.1-.8 1.6L8.8 22H3.7c-.4 1.3-.8 2.6-1.1 4"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ed4c5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3 14.4c-.8-1.1-1.6-2.1-2.5-3.1L42 19.9v2h4l10.3-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22L7.9 14.2c-.4.5-.7 1-1.1 1.5c-.1.1-.1.2-.2.2c-.3.5-.7 1.1-1 1.6l6.1 4.5h6.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4 26H38V2.6c-1.9-.4-3.9-.6-6-.6s-4.1.2-6 .6V26H2.6c-.4 1.9-.6 3.9-.6 6s.2 4.1.6 6H26v23.4c1.9.4 3.9.6 6 .6s4.1-.2 6-.6V38h23.4c.4-1.9.6-3.9.6-6s-.2-4.1-.6-6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.c295099f56f5ece434af717e4964ec4f.svg";
export { ForwardRef as ReactComponent };